<template>
  <div class="column_center_start w-full">
    <!-- 消費模式選擇區域 -->
    <div class="mt-8 w-full" :class="isLogin ? 'opacity-100 pointer-events-auto' : 'opacity-40 pointer-events-none'">
      <!-- 統一顯示消費模式按鈕（單模式和多模式都使用相同樣式） -->
      <div v-if="shouldShowModeButton" class="consumption-mode-selector" @click="showConsumptionModePopup">
        <div class="mode-selector-button">
          <span class="mode-selector-text">{{ currentModeText }}</span>
          <div class="mode-selector-arrow-container">
            <text class="button-icon mode-selector-arrow">expand_more</text>
          </div>
        </div>
      </div>
    </div>
    
    <div class="w-full column_center_center fused-content" v-if="isPageLoading || isLoadingData">
      <loadingOrder></loadingOrder>
    </div>
    
    <div class="w-full column_center_center fused-content" v-else-if="isLogin">
      <disabledOrder v-if="showDisabledOrder"></disabledOrder>
      <dineIn v-else-if="showDineInTab" @toOrderPage="toOrderPage"></dineIn>
      <toGo v-else-if="showToGoTab" @toOrderPage="toOrderPage"></toGo>
      <pickUp v-else-if="showPickUpTab" :is-retail-pick-up="currentModeMethod === 'retailPickUp'" @toOrderPage="toOrderPage"></pickUp>
      <delivery v-else-if="showDeliveryTab" :is-retail-delivery="currentModeMethod === 'retailDelivery'" @toOrderPage="toOrderPage"></delivery>
      <disabledOrder v-else></disabledOrder>
    </div>
    
    <loginCard v-else @login="lineLogin"></loginCard>
    <storeInfoDetail></storeInfoDetail>
    <button v-if="!isLogin" class="button my-4" style="width: 92vw; background-color: #fff"
      @click="toMemberPage">返回VIP會員卡</button>
    
    <!-- 新增：店家公告跳窗組件 -->
    <StoreNoticePopup />
    
    <!-- 新增：消費模式選擇跳窗 -->
    <ConsumptionModePopup 
      :visible="showModePopup" 
      :availableModes="tabs"
      @selectMode="handleModeSelection"
      @close="closeModePopup"
    />
  </div>
</template>

<script>
import StoreNoticePopup from "@/components/general/storeNoticePopup.vue";
import storeInfoDetail from "../../components/store/storeInfoDetail.vue";
import ConsumptionModePopup from "../../components/store/consumptionModePopup.vue";
import dineIn from "../../components/store/dineIn.vue";
import toGo from "../../components/store/toGo.vue";
import pickUp from "../../components/store/pickUp.vue";
import delivery from "../../components/store/delivery.vue";
import disabledOrder from "@/components/store/disabledOrder.vue";
import loadingOrder from "@/components/store/loadingOrder.vue";
import loginCard from "@/components/store/loginCard.vue";
import commonUtilities from "@/utils/common.utils";
import auth from "@/utils/auth.utils";
import apiData from "@/services/apiData";
import {
  mapState,
  mapGetters
} from 'vuex';
export default {
  components: {
    storeInfoDetail: storeInfoDetail,
    ConsumptionModePopup: ConsumptionModePopup,
    dineIn: dineIn,
    toGo: toGo,
    pickUp: pickUp,
    delivery: delivery,
    loginCard: loginCard,
    disabledOrder: disabledOrder,
    loadingOrder: loadingOrder,
    StoreNoticePopup
  },
  data() {
    return {
      currentTabIndex: 0,
      userHasSelectedTab: false,
      showModePopup: false, // 新增：控制跳窗顯示狀態
      hasAutoShownPopup: false, // 新增：記錄是否已自動顯示過跳窗
      isPageLoading: true, // 頁面整體載入狀態，防止資料未就緒時閃現「線上點餐暫停中」
    };
  },
  watch: {
    async errorLoginState(state) {
      if (state) {
        //關閉 loading 彈窗
        commonUtilities.closeLoading();
        let errorMessage = this.errorLoginMessage
        if (errorMessage === 'IdToken expired.') {
          this.$store.commit('line/setLineLoginData', {})
          return
        }
        if (errorMessage == 'No Such Store') {
          errorMessage = '查無此店家'
        }
        commonUtilities.createToast(
          "error",
          "登入失敗",
          errorMessage
        );

        // auth.logout()
      }
    },
    // 新增：監聽消費模式數量變化，自動顯示跳窗
    shouldShowModePopup: {
      handler(newVal) {
        // 當滿足顯示跳窗條件且尚未自動顯示過且使用者已登入時，自動顯示跳窗
        if (newVal && !this.hasAutoShownPopup && !this.userHasSelectedTab && this.isLogin)  {
          this.$nextTick(() => {
            this.showModePopup = true
            this.hasAutoShownPopup = true
          })
        }
      },
      immediate: true // 立即執行一次
    }
  },
  computed: {
    tabs() {
      const tabs = []
      const dineInTab = {
        name: '門市內用',
        enabled: this.enableDineIn
      }
      const toGoTab = {
        name: '現場外帶',
        enabled: this.enableToGo
      }
      const pickUpTab = {
        name: '預約自取',
        enabled: this.enablePickUp
      }
      const deliveryTab = {
        name: '店家外送',
        enabled: this.enableDelivery
      }
      const retailPickUpTab = {
        name: '零售自取',
        enabled: this.enableRetailCheckout
      }
      const retailDeliveryTab = {
        name: '零售宅配',
        enabled: this.enableRetailDelivery
      }
      if (this.enableDineIn) {
        tabs.push(dineInTab)
      }
      if (this.enableToGo) {
        tabs.push(toGoTab)
      }
      if (this.enablePickUp) {
        tabs.push(pickUpTab)
      }
      if (this.enableDelivery) {
        tabs.push(deliveryTab)
      }
      if (this.enableRetailCheckout) {
        tabs.push(retailPickUpTab)
      }
      if (this.enableRetailDelivery) {
        tabs.push(retailDeliveryTab)
      }
      return tabs
    },
    dineInIndex() {
      return this.tabs.findIndex(tab => tab.name === '門市內用')
    },
    toGoIndex() {
      return this.tabs.findIndex(tab => tab.name === '現場外帶')
    },
    pickUpIndex() {
      return this.tabs.findIndex(tab => tab.name === '預約自取')
    },
    deliveryIndex() {
      return this.tabs.findIndex(tab => tab.name === '店家外送')
    },
    retailPickUpIndex() {
      return this.tabs.findIndex(tab => tab.name === '零售自取')
    },
    retailDeliveryIndex() {
      return this.tabs.findIndex(tab => tab.name === '零售宅配')
    },
    showDineInTab() {
      // 如果是單模式且該模式是內用，直接顯示
      if (this.tabs.length === 1 && this.singleModeIndex === this.dineInIndex) {
        return this.enableDineIn && this.activeOnlineOrder
      }
      // 原有邏輯保持不變
      return this.currentTabIndex === this.dineInIndex && this.enableDineIn && this.activeOnlineOrder
    },
    showToGoTab() {
      // 如果是單模式且該模式是外帶，直接顯示
      if (this.tabs.length === 1 && this.singleModeIndex === this.toGoIndex) {
        return this.enableToGo && this.activeOnlineOrder
      }
      // 原有邏輯保持不變
      return this.currentTabIndex === this.toGoIndex && this.enableToGo && this.activeOnlineOrder
    },
    showPickUpTab() {
      // 如果是單模式且該模式是自取，直接顯示
      if (this.tabs.length === 1 && [this.pickUpIndex, this.retailPickUpIndex].includes(this.singleModeIndex)) {
        return (this.enablePickUp || this.enableRetailCheckout) && this.activeOnlineOrder
      }
      // 原有邏輯保持不變
      return [this.pickUpIndex, this.retailPickUpIndex].includes(this.currentTabIndex) && (this.enablePickUp || this.enableRetailCheckout) && this.activeOnlineOrder
    },
    showDeliveryTab() {
      // 如果是單模式且該模式是外送，直接顯示
      if (this.tabs.length === 1 && [this.deliveryIndex, this.retailDeliveryIndex].includes(this.singleModeIndex)) {
        return (this.enableDelivery || this.enableRetailDelivery) && this.activeOnlineOrder
      }
      // 原有邏輯保持不變
      return [this.deliveryIndex, this.retailDeliveryIndex].includes(this.currentTabIndex) && (this.enableDelivery || this.enableRetailDelivery) && this.activeOnlineOrder
    },
    showDisabledOrder() {
      return !this.activeOnlineOrder || !this.tabs.length
    },
    
    // 新增：智慧顯示相關 computed
    // 修改：統一的按鈮顯示條件（單模式和多模式都顯示按鈕）
    shouldShowModeButton() {
      return this.tabs.length >= 1 && this.activeOnlineOrder
    },
    // 修改：shouldShowModePopup 改為只判斷是否為多模式（用於自動跳窗邏輯）
    shouldShowModePopup() {
      return this.tabs.length > 1 && this.activeOnlineOrder
    },
    singleModeIndex() {
      return this.tabs.length === 1 ? 0 : -1
    },
    // 移除：showSingleMode computed（不再需要）
    // 修改：當前選中模式的文字顯示（自動偵測）
    currentModeText() {
      // 優先顯示當前 tab 的名稱，不需要等待用戶選擇
      if (this.tabs[this.currentTabIndex]) {
        return this.tabs[this.currentTabIndex].name
      }
      return '請選擇消費模式'
    },
    currentModeMethod() {
      const mode = this.tabs[this.currentTabIndex]?.name
      switch (mode) {
        case '門市內用':
          return 'dineIn'
        case '現場外帶':
          return 'takeOut'
        case '預約自取':
          return 'pickUp'
        case '店家外送':
          return 'delivery'
        case '零售自取':
          return 'retailPickUp'
        case '零售宅配':
          return 'retailDelivery'
        default:
          return ''
      }
    },
    ...mapGetters('basic', {
      errorLoginState: 'errorLoginState',
      errorLoginMessage: 'errorLoginMessage',
      storeName: 'storeName',
      googleSheetId: 'googleSheetId',
      enableDineIn: 'enableDineIn',
      enableToGo: 'enableToGo',
      enablePickUp: 'enablePickUp',
      enableDelivery: 'enableDelivery',
      enableRetailCheckout: 'enableRetailCheckout',
      enableRetailDelivery: 'enableRetailDelivery',
      activeOnlineOrder: 'activeOnlineOrder'
    }),
    ...mapState('basic', {
      currentStore: 'currentStore',
    }),
    ...mapGetters('userData', {
      isLogin: 'isLogin',
      isStoreMember: 'isStoreMember',
      storeCode: 'storeCode',
      accessToken: 'accessToken',
    }),
    ...mapGetters('line', {
      lineAccessToken: 'accessToken'
    }),
    areaId() {
      return this.$store.getters['cart/tableAreaId']
    },
    tableIndex() {
      return this.$store.getters['cart/tableIndex']
    },
    routerParams() {
      return this.$route.params;
    },
    routerStoreCode() {
      return this.routerParams.store
    },
    isLoadingData() {
      if (!this.enableDineIn) return false
      return !this.$store.state.spreadsheet.dineInTablesLoaded
    }
  },
  async mounted() {
    await this.init()
    this.tabIndexInit()
  },
  methods: {
    tabIndexInit() {
      if (this.userHasSelectedTab) return

      // 如果是單一模式，直接設定為該模式
      if (this.tabs.length === 1) {
        this.currentTabIndex = this.singleModeIndex
        return
      }

      // 原有邏輯保持不變
      this.currentTabIndex = this.tabs.findIndex(tab => tab.enabled)
      if (this.currentTabIndex === -1) {
        this.currentTabIndex = 0
      }
    },
    setCurrentTab(index) {
      if (!this.activeOnlineOrder) return
      this.currentTabIndex = index;
      this.userHasSelectedTab = true;
    },
    
    // 修改：顯示消費模式選擇跳窗（支援單模式和多模式）
    showConsumptionModePopup() {
      // 只要有消費模式就可以顯示跳窗（單模式或多模式都可以）
      if (this.shouldShowModeButton) {
        this.showModePopup = true
      }
    },
    
    // 修改：處理消費模式選擇
    handleModeSelection(data) {
      // 根據選擇的模式設定 currentTabIndex
      const modeIndex = this.tabs.findIndex(tab => {
        switch(data.mode) {
          case 'dineIn': return tab.name === '門市內用'
          case 'takeOut': return tab.name === '現場外帶'
          case 'pickUp': return tab.name === '預約自取'
          case 'delivery': return tab.name === '店家外送'
          case 'retailPickUp': return tab.name === '零售自取'
          case 'retailDelivery': return tab.name === '零售宅配'
          default: return false
        }
      })
      
      if (modeIndex !== -1) {
        this.currentTabIndex = modeIndex
        this.userHasSelectedTab = true
      }
      
      this.showModePopup = false
      this.hasAutoShownPopup = true // 標記已處理過自動跳窗
    },
    
    // 修改：關閉跳窗
    closeModePopup() {
      this.showModePopup = false
      this.hasAutoShownPopup = true // 標記已處理過自動跳窗
    },
    async init() {
      // 頁面開始載入，顯示 loading 畫面
      this.isPageLoading = true
      // 新增：重置自動跳窗狀態
      this.hasAutoShownPopup = false
      this.userHasSelectedTab = false
      
      let loginProcess = false
      // 重置商店菜單資料
      await this.$store.dispatch('spreadsheet/clearData', [])
      this.$store.commit('order/setOrderSpecs', [])
      // 重置商店資訊
      this.$store.commit('basic/setStoreInfo', {})
      /*
        如果有 line access token 則進行 okShopLogin
        登入後判斷是否為該商店會員 若不是商店會員則直接幫用戶加入會員
      */
      if (!this.isLogin && this.lineAccessToken) {
        loginProcess = true
        // 顯示讀loading 彈窗
        /*
        //MOdify By Bryant 2025061701
        commonUtilities.createLoading("資料讀取中", "請稍後");
        */
        try {
          await auth.okShopLogin()
        } catch (e) {
          console.error("Failed to login gen2 pos system:", e);
          this.$store.dispatch("basic/setErrorLogin", { state: true, message: e });
          //Modify By Bryant 2025061701
          commonUtilities.closeLoading()
          // 登入失敗，關閉頁面 loading 狀態
          this.isPageLoading = false
          return
        }
      } else if (!this.accessToken) {
        // 如果沒有 okshop access token || line access token 則不進行任何動作
        //Modify By Bryant 2025061701
        commonUtilities.closeLoading()
        this.isPageLoading = false
        return
      }

      try {
        if (!commonUtilities.isLoadingShow()) {
          /*
          //Modify By Bryant 2025061701
          commonUtilities.createLoading("資料讀取中", "請稍後");
          */
        }
        // 如果目前 routerStoreCode 與 storeCode 不同，則需要使用切換商店 api
        if (this.routerStoreCode !== this.storeCode) {
          await this.$store.dispatch('userData/changeStore', {
            store_code: this.routerStoreCode
          })
        }

        // 如果不是該商店會員 則進行加入會員
        if (!this.isStoreMember) {
          await this.$store.dispatch('userData/joinMember')
        }
        this.$store.commit('cart/setTableData', {})
        this.$store.commit('cart/setTakeOutTableData', {})
        // 重置購物車資料
        this.$store.commit('cart/setCart', [])
        // 重置訂單資料
        this.$store.commit("cart/setPayment", {})
        // 重置會員資料
        this.$store.commit('userData/setMemberInfo', {})
        // 取得商店資訊
        await this.$store.dispatch('basic/fetchStoreInfo')
        // 取得會員資訊
        await this.$store.dispatch('userData/fetchMemberInfo')
        // 取得桌號資料（DB 優先，無資料時 fallback 至 Google Sheets）
        await this.$store.dispatch('spreadsheet/loadDineInTables')
        // 取得支付設定列表
        await this.$store.dispatch('payment/getPaymentMethods')
        // 取得商店服務列表
        await this.$store.dispatch('basic/fetchStoreServicesList')
        // 剩餘資料可在背景讀取
        this.$store.dispatch('userData/fetchPointHistory')
        commonUtilities.closeLoading();
        // 資料載入完成，關閉頁面 loading 狀態
        this.isPageLoading = false
        if (loginProcess) {
          await commonUtilities.delay(300)
          commonUtilities.createToast("success", "登入成功", "")
        }
      } catch (e) {
        if (e === 'No Such Store') {
          this.toMemberPage()
          return
        }
        console.error(e)
        commonUtilities.closeLoading()
        // 發生錯誤，關閉頁面 loading 狀態
        this.isPageLoading = false
        await commonUtilities.delay(300)
        commonUtilities.createToast("error", `${e}`)
      }
    },
    lineLogin() {
      const data = new apiData();
      data.store = this.routerStoreCode;
      data.data = {
        method: 'store',
      };
      this.$store.dispatch('line/login', data)
    },
    toMemberPage() {
      this.$router.push(`/${this.routerStoreCode}`)
    },
    async toOrderPage(data) {
      if (!this.isLogin) {
        await this.init()
        return
      }
      const process = 'ordering'
      const method = this.currentModeMethod || data.method
      // 設定 payment 用餐模式
      if (method == 'dineIn') {
        await this.$store.commit("cart/setPayment", {
          ...this.$store.state.cart.payment,
          consumptionPattern: 0
        })
      } else if (method == 'takeOut') {
        await this.$store.commit("cart/setPayment", {
          ...this.$store.state.cart.payment,
          consumptionPattern: 1
        })
      } else if (method == 'pickUp') {
        await this.$store.commit("cart/setPayment", {
          ...this.$store.state.cart.payment,
          consumptionPattern: 2
        })
      } else if (method == 'delivery') {
        await this.$store.commit("cart/setPayment", {
          ...this.$store.state.cart.payment,
          consumptionPattern: 3
        })
      } else if (method == 'retailPickUp') {
        await this.$store.commit("cart/setPayment", {
          ...this.$store.state.cart.payment,
          consumptionPattern: 4
        })
      } else if (method == 'retailDelivery') {
        await this.$store.commit("cart/setPayment", {
          ...this.$store.state.cart.payment,
          consumptionPattern: 5
        })
      }
      this.$router.push({
        path: `/${this.routerStoreCode}/${process}/${method}/${this.areaId}/${this.tableIndex}`,
        query: { orderSource: 'onlineOrder' }
      })
    },
  },
};
</script>

<style lang="scss">
.title {
  font-family: PingFang SC;
  font-size: 20px;
  font-weight: 600;
}

.input {
  font-family: PingFang SC;
  width: 100%;
  padding: 0 2%;
  height: 54px;
  border: 1px solid #AAAAAA;
  border-radius: 6px;
  margin: 10px 0;
  font-size: 22px;
  text-align: center;
  color: rgba(0, 0, 0, 0.3);
  font-weight: 400;
  flex-shrink: 0;
}

// .input:focus {
//   如果有需要調整 input focus 的樣式，可以在這裡調整
//     outline: none;
//     border: 1px solid #707070;
// }

.input::-webkit-input-placeholder {
  color: rgba($color: #000000, $alpha: 0.3);
  font-weight: 400;
}

.input:-moz-placeholder {
  /* Firefox 18- */
  color: rgba($color: #000000, $alpha: 0.3);
  font-weight: 400;
}

.input::-moz-placeholder {
  /* Firefox 19+ */
  color: rgba($color: #000000, $alpha: 0.3);
  font-weight: 400;
}

.input:-ms-input-placeholder {
  color: rgba($color: #000000, $alpha: 0.3);
  font-weight: 400;
}

// 新增：消費模式選擇器樣式（卡片風格）
.consumption-mode-selector {
  width: 92%;
  cursor: pointer;
  margin: 0 auto;
}

.mode-selector-button {
  display: flex;
  justify-content: center; // 改為 center，讓文字居中
  align-items: center;
  width: 100%;
  padding: 15px 30px;
  border-radius: 6px 6px 0 0; // 只保留上圓角
  background-color: #EEEEEE;
  border: none;
  font-weight: 500;
  font-size: 24px;
  color: #333;
  transition: all 0.2s ease;
  box-shadow: 0px 0px 8px #0000001A;
  margin-bottom: 0; // 確保沒有下邊距
  position: relative; // 新增：為箭頭絕對定位做準備
}

.mode-selector-text {
  font-family: PingFang SC, sans-serif;
  font-weight: 500;
  color: #FD5001; // 新增：橘紅色文字
}

// 新增：箭頭容器樣式
.mode-selector-arrow-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  transition: all 0.2s ease;
  position: absolute; // 新增：絕對定位
  right: 20px; // 新增：固定在右側
} 

.mode-selector-arrow {
  font-size: 20px;
  color: #FD5001; // 修改：改為橘紅色
  transition: color 0.2s ease;
  
  .mode-selector-arrow-container:hover & {
    color: #000; // 懸停時變黑色
  }
}

// 響應式設計
@media (max-width: 480px) {
  .mode-selector-button {
    padding: 13px 24px;
    font-size: 24px;
  }
  
  .mode-selector-arrow-container {
    width: 28px;
    height: 28px;
    right: 18px; // 小螢幕時調整位置
  }
  
  .mode-selector-arrow {
    font-size: 18px;
  }
  
  .consumption-mode-selector {
    width: 92% !important; // 修改：與 order_method_container 保持一致
  }
  
}

// 融合內容樣式
.fused-content {
  margin-top: 0 !important;
  
  // 當有消費模式選擇器時，調整下方卡片樣式
  .order_method_container {
    border-radius: 0 0 6px 6px !important; // 只保留下圓角
    margin-top: 0 !important;
    box-shadow: 0px 2px 8px #0000001A !important; // 調整陰影，避免與上方重疊
  }
}
</style>
